/* 
 * NOTICE OF LICENSE
 * 
 * This source file is subject to the Academic Free License (AFL 3.0)
 * 
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2019 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

import $ from 'jquery';

export default function($){
    
    var cursor = document.querySelector('.js-cursor');

    document.addEventListener('mousemove', function(e){
        var x = e.clientX;
        var y = e.clientY;
        cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`
    });

    $(".js-caseStudies-slider").on("mouseenter", function() {
        $('.js-cursor').addClass("arrows");
    });
    $(".js-caseStudies-slider").on("mouseleave", function() {
        $('.js-cursor').removeClass("arrows");
    });
    
    $(".js-mouse-hover, a, .js-back-to-top").on("mouseenter", function() {
        $('.js-cursor').addClass("mouse-hover");
    });
    $(".js-mouse-hover, a, .js-back-to-top").on("mouseleave", function() {
        $('.js-cursor').removeClass("mouse-hover");
    });
}